import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class PermissaoResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  listByControlador(id) {
    return this.http.get(`${this.resource}/list/${id}`);
  }
}

const resource = 'permissao';

const permissaoHttp = new PermissaoResourceHttp(clientHttp, prefixBase + resource);

export default permissaoHttp;
